export const handleBackClick = (history, defaultPath) => () => {
  history.push(defaultPath);
};
